/*
Monotype Foundry Platform API
Version 1.0.0

Definition: SalesReportSummaryRequest

Properties:
  filter: object
  searchQuery: string
*/

var SalesReportSummaryRequest = (function () {
  function validateSalesReportSummaryRequest (arg) {
    // Validate filter
    if (arg.filter && !(typeof arg.filter === 'object')) {
      throw new Error('SalesReportSummaryRequest.filter: Wrong type: Got \'' + (typeof arg.filter) + '\', but expected: \'object\'')
    }
    // Validate searchQuery
    if (arg.searchQuery && !(typeof arg.searchQuery === 'string')) {
      throw new Error('SalesReportSummaryRequest.searchQuery: Wrong type: Got \'' + (typeof arg.searchQuery) + '\', but expected: \'string\'')
    }
  }
  function buildSalesReportSummaryRequest (arg) {
    var SalesReportSummaryRequest = arg
    // Complete filter
    // Expected Type: object
    SalesReportSummaryRequest.filter = SalesReportSummaryRequest.filter || {}
    // Complete searchQuery
    // Expected Type: string
    SalesReportSummaryRequest.searchQuery = SalesReportSummaryRequest.searchQuery || ''
    return SalesReportSummaryRequest
  }
  return {
    validate: validateSalesReportSummaryRequest,
    build: buildSalesReportSummaryRequest
  }
})()

module.exports = SalesReportSummaryRequest
